export const truncateString = (str, characterLimit) => {
  return str.length >= characterLimit ? `${str.slice(0, characterLimit)}...` : str;
};